import fetch from "auth/FetchInterceptor";

const ApplicationSlice = {};

ApplicationSlice.GetApplicationSSR = async function (data) {
  return fetch({
    url: "/Application/GetAllSSR",
    method: "post",
    data: data,
  });
};
ApplicationSlice.GetApplicationById = async function (params) {
  return fetch({
    url: "/Application/GetById",
    method: "get",
    params,
  });
};
ApplicationSlice.Create = async function (data) {
  return fetch({
    url: "/Application/Create",
    method: "post",
    data,
  });
};
ApplicationSlice.BulkCreate = async function (data) {
  return fetch({
    url: "/Application/CreateRange",
    method: "post",
    data,
  });
};
ApplicationSlice.SetActive = async function (params) {
  return fetch({
    url: "/Application/SetIsActive",
    method: "get",
    params,
  });
};
ApplicationSlice.GetApplicationStatus = async function () {
  return fetch({
    url: "/Application/GetApplicationStatus",
    method: "get",
  });
};
ApplicationSlice.GetApplicationsByCandidateId = async function (params) {
  return fetch({
    url: "/Application/GetApplicationsByCandidateId",
    method: "get",
    params,
  });
};
ApplicationSlice.SetIsViewedStatus = async function (params) {
  return fetch({
    url: "/Application/SetIsViewed",
    method: "post",
    params,
  });
};
ApplicationSlice.SetIsDownloadedStatus = async function (params) {
  return fetch({
    url: "/Application/SetIsDownloaded",
    method: "post",
    params,
  });
};
ApplicationSlice.SetIsShortListedStatus = async function (params) {
  return fetch({
    url: "/Application/SetIsShortListed",
    method: "get",
    params,
  });
};
ApplicationSlice.SetIsHired = async function (params) {
  return fetch({
    url: "/Application/SetIsHired",
    method: "get",
    params,
  });
};
ApplicationSlice.SetIsScheduled = async function (params) {
  return fetch({
    url: "/Application/SetIsScheduled",
    method: "get",
    params,
  });
};
ApplicationSlice.ChangeStatus = async function (params) {
  return fetch({
    url: "/Application/ChangeStatus",
    method: "post",
    params,
  });
};
ApplicationSlice.AssignToHRAssessment = async function (params) {
  return fetch({
    url: "/Application/AssignToHRAssessment",
    method: "post",
    params,
  });
};
ApplicationSlice.ApproveApplication = async function (data) {
  return fetch({
    url: "/Application/ApproveApplication",
    method: "post",
    data,
  });
};
ApplicationSlice.BulkChangeStatus = async function (params, data) {
  return fetch({
    url: "/Application/BulkChangeStatus",
    method: "post",
    params,
    data,
  });
};
export default ApplicationSlice;
